/**
 * benchmarkHints — surface the Read Me BENCHMARK_RANGES as directional helper text next to the
 * matching calculator input. The ranges are captured as structured data in lib/roi/presets.ts;
 * this only picks the string for the currently selected charger type. Returns null when a metric
 * has no benchmark, so an input with no published range simply renders no hint.
 *
 * The form decides which metric label sits beside which input (and which belong beside a RESULT,
 * e.g. "Typical simple payback"); keeping that mapping in the view keeps this helper a pure lookup.
 */
import { BENCHMARK_RANGES, type ChargerType } from '../../lib/roi/presets'

export function benchmarkHint(metric: string, type: ChargerType): string | null {
  const range = BENCHMARK_RANGES.find((b) => b.metric === metric)
  if (!range) return null
  return type === 'dcfc' ? range.dcfc : range.l2
}
